import {useIntl} from 'react-intl'

/**
 * Hook to get billing-related translations
 * @returns Object with billing translation functions
 */
export const useCandiTranslations = () => {
  const intl = useIntl()

  const t = (id: string) => intl.formatMessage({id})

  return {
    // Header translations
    startCycle: () => t('HEADERS.START_CYCLE'),
    endCycle: () => t('HEADERS.END_CYCLE'),
    careMins: () => t('HEADERS.CARE_MINS'),
    readings: () => t('HEADERS.READINGS'),
    cpt99445: () => t('HEADERS.CPT_99445'),
    cpt99453: () => t('HEADERS.CPT_99453'),
    cpt99454: () => t('HEADERS.CPT_99454'),
    cpt99457: () => t('HEADERS.CPT_99457'),
    cpt99458: () => t('HEADERS.CPT_99458'),
    cpt99470: () => t('HEADERS.CPT_99470'),
    patient: () => t('HEADERS.PATIENT'),
    dob: () => t('HEADERS.DOB'),

    // Status translations
    eligible: () => t('HEADERS.STATUS.ELIGIBLE'),
    ineligible: () => t('HEADERS.STATUS.INELIGIBLE'),
  }
}

/**
 * Get billing header translations without React hook
 * For use in non-React contexts like constants files
 */
export const getCandiTranslations = () => {
  // This is a fallback for non-React contexts
  // In a real implementation, you might want to use a different approach
  return {
    cycle: 'Billing Cycle',
    startCycle: 'Start',
    endCycle: 'End',
    careMins: 'Care Mins',
    readings: 'Readings',
    cpt99445: '99445',
    cpt99453: '99453',
    cpt99454: '99454',
    cpt99457: '99457',
    cpt99458: '99458',
    cpt99470: '99470',
    patient: 'Patient',
    dob: 'DOB',
    eligible: 'Eligible',
    ineligible: 'Ineligible',
  }
}
